import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';

import { withAuthorization } from '../../../session/index';
import { CardHeader } from 'reactstrap';
import { Review } from './review/Review';
import { getReviewsByPostUId } from '../../../firebase/api/review';
import { FEEDBACK_TABLE_SIZE } from '../../../configs';
import { Button } from 'reactstrap';
import * as QUESTION from '../../../constants/questions';
import YesNoStatistic from '../../elements/YesNoStatistic/YesNoStatistic';
import { Categories, DefaultCategory } from '../../../static/categories';
import MultipleStatistic from '../../elements/MultipleStatistic/MultipleStatistic';
import PostInviteModal from '../../elements/customModals/PostInviteModal/PostInviteModal';
import { updatePost } from '../../../firebase/api/post';
import { getUserByUid } from '../../../firebase/api/users';
import './ReviewsTable.css';
import { ReactComponent as EmailAllIcon } from '../../../pages/Posts/components/PostFooter/Email_all_icon.svg';

class ReviewsTable extends Component {
    state = {
        postReviews: [],
        lastVisibleDocument: null,
        showFeedback: false,
        showMore: true,
        showInviteModal: false,
    };

    componentDidMount() {
        this.getReviews(this.state.lastVisibleDocument);
    }

    getReviews(lastElement) {
        getReviewsByPostUId(FEEDBACK_TABLE_SIZE, this.props.post.uid, lastElement).then(result => {
            this.populateSearchResult(result);
        });
    }

    moreReviews = () => {
        this.getReviews(this.state.lastVisibleDocument);
    };

    populateSearchResult = results => {
        const postReviews = [...this.state.postReviews];
        if (results) {
            let lastVisibleDocument = null;
            results.forEach(function (doc) {
                lastVisibleDocument = doc;
                const data = doc.data();
                getUserByUid(data.publisherUid).then(user => {
                    data.publisher = user;
                });
                postReviews.push(data);
            });
            this.setState({ postReviews, lastVisibleDocument });
            results.docs &&
                results.docs.length < FEEDBACK_TABLE_SIZE &&
                this.setState({ showMore: false });
        } else {
            this.setState({ showMore: false });
        }
    };

    showFeedback = () => {
        this.setState({ showFeedback: !this.state.showFeedback });
        this.props.onReviewButtonClick();
    };

    inviteUsersToggle = inviteAllUsers => {
        const { post } = this.props;

        if (post.inviteAllUsers !== inviteAllUsers || post.inviteAllUsers === undefined) {
            post.inviteAllUsers = inviteAllUsers;
            console.log('update');
            updatePost(post).then(result => {
                if (result) {
                    this.setState(prevState => ({
                        showInviteModal: !prevState.showInviteModal,
                    }));
                }
            });
        } else {
            this.setState(prevState => ({
                showInviteModal: !prevState.showInviteModal,
            }));
        }
    };

    render() {
        const { showFeedback, showMore, postReviews, showInviteModal } = this.state;

        const { post } = this.props;

        const postCategory =
            post.category && Categories[post.category]
                ? Categories[post.category]
                : DefaultCategory;
        const textStyle = { color: `${postCategory.color}` };

        return (
            <CardHeader className="post-comments">
                <div className="post-comments-row">
                    <div className="post-comments-button">
                        <Button
                            outline
                            className="mr-2"
                            color="light"
                            onClick={() => this.setState({ showInviteModal: !showInviteModal })}
                        >
                            Invite
                        </Button>
                        {postReviews && postReviews.length > 0 && (
                            <Button
                                outline
                                className="mr-2 email-all-button"
                                color="light"
                                onClick={this.props.onEmailButtonClick}
                            >
                                <EmailAllIcon />
                                <span className="ml-2">Email All</span>
                            </Button>
                        )}
                    </div>
                    {postReviews.length > 0 ? (
                        <div className="postFeedbackButton" onClick={this.showFeedback}>
                            <p>
                                {showFeedback ? (
                                    <span className="d-flex align-items-center">
                                        Close {postReviews.length} Comments
                                        <i className="material-icons">keyboard_arrow_up</i>
                                    </span>
                                ) : (
                                    <span className="d-flex align-items-center">
                                        {postReviews.length} Comments
                                        <i className="material-icons">keyboard_arrow_down</i>
                                    </span>
                                )}
                            </p>
                        </div>
                    ) : (
                        <div className="postFeedbackButton">
                            <p>No comments</p>
                        </div>
                    )}
                    <div className="post-comments-statistic">
                        {post.question.type === QUESTION.YES_NO && (
                            <YesNoStatistic color={postCategory.color} post={post} />
                        )}
                        {post.question.type === QUESTION.MULTIPLE && (
                            <MultipleStatistic color={postCategory.color} post={post} />
                        )}
                    </div>
                </div>
                {showFeedback && (
                    <div>
                        {postReviews && postReviews.length === 0 && <p>no feedback</p>}
                        {postReviews &&
                            postReviews.map((review, index) => (
                                <Review
                                    key={index}
                                    user={review.publisher}
                                    postType={post.question.type}
                                    review={review}
                                />
                            ))}
                        {showMore && (
                            <div className="postFeedbackButton" onClick={this.moreReviews}>
                                <p>more...</p>
                            </div>
                        )}
                    </div>
                )}
                <PostInviteModal
                    post={post}
                    modal={showInviteModal}
                    toggle={this.inviteUsersToggle}
                />
            </CardHeader>
        );
    }
}

//const condition = authUser => !!authUser && authUser.acceptPolicy === true;
const condition = authUser => !!authUser;

ReviewsTable.propTypes = {
    onReviewButtonClick: PropTypes.func.isRequired,
    onEmailButtonClick: PropTypes.func.isRequired,
};

export default compose(withAuthorization(condition))(ReviewsTable);
